export function formatPrice(
  price: number | string | undefined,
  template: string | undefined,
): string {
  if (price === undefined) {
    return "N/A";
  }

  // We can easily convert price to number because it comes in a string without decimals like "130000"
  const priceNumber = Number(price);
  const formattedWithDecimals = priceNumber.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  const formattedNoDecimals = priceNumber.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  return template && template.includes("{{")
    ? template
        .replace("{{amount}}", formattedWithDecimals.replace("$", ""))
        .replace("{{amount_no_decimals}}", formattedNoDecimals.replace("$", ""))
    : formattedWithDecimals;
}
